import React, { useMemo, useRef, useState, useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import ActionMenu from '@/components/ContainerList/ActionMenu';
import styles from './containerList.module.css';
import ContainerInfoRow from '@/ctComponents/ContainerInfoRow';
import IconButton from '@/ctComponents/IconButton';
import AutobookTimeDateSelector from './AutobookTimeDateSelector';
import Modal from '@/ctComponents/Modal';
import { useSelector } from 'react-redux';
import { formatDateToUTC } from '@/ctUtlis/formatDate';
import {
  deleteAutobooks,
  deleteAutobookTemplate,
  editAutoBookContainerData,
  editAutobookTemplate,
  enableAutoBook,
  loadAutobookTemplateForContainers,
  SaveApiResMessage,
  getAutoBookContainerData,
  AutoBookIndex,
} from '@/actions';
import { useNotify } from 'react-admin';
import CustomSwitch from '../../components/CostomSwitch/CustomSwitch';
import Appointments from '../Inventory/Appointments';
import { noScroll } from '@/actions/Helper';
import LoadingV2 from '@/components/Loading';
import SubmitButton from '@/ctComponents/submitButton';
import { saveAutobookPreferences } from '@/actions';
import { CustomCircularProgress } from '@/components/Loading/CustomCircularProgress';

const AutobookList = ({
  onLoadItemClick,
  onSave,
  onHistory,
  historyList,
  setHistoryList,
  clickConatiner,
  tableData,
  autobookAppointmentsApiData,
  settings,
  setSettings,
  saving_identifier,
  status,
  setStatus,
  loading,
  ABloading,
  setABloading,
  setLoading,
  width,
  selectedContainers,
  selectedContainer,
  setSavedTemplates,
  savedTemplates,
  setReLoadAutobook,
  setReLoadAutobookContainer,
  setShowSavePreferences,
  showSavePreferences,
  reLoadAutobook,
  autobookMode,
  setAutobookMode,
  setSelectedContainers,
  setSelectedContainer,
  setClickConatiner,
  activeSection,
  setActiveSection,
  clickedTemplate,
  setClickedTemplate,
  preferenceName,
  setPreferenceName,
  activeTab,
  setActiveTab,
  actionMenuAnchor,
  setActionMenuAnchor,
  collapsedRow,
  setCollapsedRow,
  autobookModeLoading,
  setAutobookModeLoading,
  parent,
  setAutobookModeapiRes,
  onAutobookModeChange,
}) => {
  const notify = useNotify();
  const [loadAnchorEl, setLoadAnchorEl] = useState(null);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [heightUpperThenVh, setHeightUpperThenVh] = useState(0);
  const [smallScreen, setSmallScreen] = useState(false);
  const [showDeleteTemplateModal, setShowDeleteTemplateModal] = useState(false);
  const [loadingDeleteTemplate, setLoadingDeleteTemplate] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [hasError, setHasError] = useState(false);
  // Add tabs array state
  const [tabs] = useState([
    {
      id: 'Booked-Appointment',
      label:
        activeTab === 'available' ? 'Book Appointment' : 'Booked Appointment',
      className: styles.bookedBtn,
    },
    {
      id: 'autobook-setting',
      label: 'AutoBook Preferences',
      className: styles.autobookSettingBtn,
    },
  ]);

  const [activeTabInList, setActiveTabInList] = useState('Booked-Appointment');
  const isAutobookToggleRef = useRef(false);

  useEffect(() => {
    noScroll();
  }, []);

  // Load templates for inventory mode
  useEffect(() => {
    if (parent === 'inventory' && tableData?.id) {
      AutoBookIndex('available', {
        specifications: [],
        shippingLines: [],
        container_name: '',
      })
        .then((res) => {
          setSavedTemplates(res.data.autobook_templates || []);
        })
        .catch((err) => {
          console.error('Error loading templates:', err);
        });
    }
  }, [parent, tableData?.id]);

  const containerUpdateEvent = useSelector(
    (state) => state.reducer?.containerUpdateEvent
  );

  useEffect(() => {
    if (containerUpdateEvent) {
      if (
        (containerUpdateEvent?.message?.status === 'RESERVED' ||
          containerUpdateEvent?.message?.status === 'EDITED') &&
        clickConatiner === autobookMode.autobookId
      ) {
        setStatus('DISABLED');
        setActiveTab('appointed');
        setReLoadAutobook(false);
      }
      if (
        containerUpdateEvent?.message?.status === 'CANCELED' &&
        clickConatiner === autobookMode.autobookId
      ) {
        setActiveTab('available');
        setReLoadAutobook(false);
      }
      handleTabChange(activeTabInList, false);
    }
  }, [containerUpdateEvent]);

  const handleTabChange = (tabId, loading = true) => {
    setActiveTabInList(tabId);

    // Direct API call when switching to autobook-setting tab
    if (tabId === 'autobook-setting' && tableData?.id) {
      setABloading(loading);
      getAutoBookContainerData(tableData.id)
        .then((res) => {
          // Update settings with fresh data from API
          if (setSettings && res.autobook?.settings) {
            setSettings(res.autobook.settings);
          }
          if (setStatus && res.autobook?.status) {
            setStatus(res.autobook.status);
            console.log('res.autobook.statusin', res.autobook.status);
          }
          if (setHistoryList && res.autobook?.event_history) {
            setHistoryList(res.autobook.event_history.reverse());
          }

          setABloading(false);
        })
        .catch((err) => {
          console.error('Error refreshing autobook data:', err);
          setABloading(false);
        });
    }
  };

  const informations = [
    { label: 'Size', field: 'size', width: '160px', flex: '0.7' },
    { label: 'SSL', field: 'ssl', width: '160px', flex: '0.7' },
    { label: 'Container', field: 'number', width: '180px', flex: '1' },
    { label: 'Type', field: 'is_liveOnLoad', width: '160px', flex: '0.9' },
    { label: 'LFD', field: 'lfd', width: '180px', flex: '0.8' },
    { label: 'License Plate', field: 'license', width: '180px', flex: '1' },
    {
      label: 'Created Date',
      field: 'created_date',
      width: '180px',
      flex: '1.2',
    },
  ];

  const autobookListBodyRef = useRef(null);

  const autobookListBodyHeight = useMemo(() => {
    return autobookListBodyRef?.current?.clientHeight;
  }, [autobookListBodyRef?.current?.clientHeight, activeSection]);

  useEffect(() => {
    const smallScreen = window.innerHeight < 800;
    setSmallScreen(smallScreen);
    const height = autobookListBodyRef?.current?.clientHeight;
    const vhToPx = window.innerHeight * 0.65;
    setHeightUpperThenVh(height > vhToPx ? vhToPx : height);
  }, [autobookListBodyRef?.current?.clientHeight, activeSection]);

  const handleLoadClick = (event) => {
    setLoadAnchorEl(event.currentTarget);
  };
  const handleHistoryClick = (event) => {
    setShowHistoryModal(true);
  };

  const handleLoadClose = () => {
    setLoadAnchorEl(null);
  };

  const handleDeleteClick = () => {
    const data = {
      autobooks: selectedContainers,
    };
    deleteAutobooks({ data })
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: res,
          mode: 'success',
        });
        setReLoadAutobook(true);
        setSelectedContainers([]);
        setSelectedContainer(null);
        setClickConatiner(false);
        setCollapsedRow(false);
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'error',
        });
      });
  };

  const handleEditTemplate = (item) => {
    handleSavePreferencesClick('edit', item);
  };

  const handleDeleteTemplate = () => {
    setLoadingDeleteTemplate(true);
    deleteAutobookTemplate({ AutobookTemplateId: clickedTemplate.value })
      .then((res) => {
        setSavedTemplates(res?.data?.templates);
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: res.message,
          mode: 'success',
        });
        setShowDeleteTemplateModal(false);
        setLoadingDeleteTemplate(false);
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err.message,
          mode: 'error',
        });
        setLoadingDeleteTemplate(false);
      });
  };

  const menuItems = (savedTemplates || []).map((item) => ({
    label: item.title,
    value: item.id,
    onClick: () => {
      if (parent === 'inventory') {
        // For inventory mode, apply template to current autobook
        loadAutobookTemplateForContainers({
          AutobookTemplateId: item.id,
          data: {
            autobooks: [tableData.id],
          },
        })
          .then((res) => {
            SaveApiResMessage({
              title: res?.data?.messageHeader,
              message: res,
              mode: 'success',
            });
            // Reload autobook data
            if (tableData?.id) {
              getAutoBookContainerData(tableData.id)
                .then((res) => {
                  if (setSettings && res.autobook?.settings) {
                    setSettings(res.autobook.settings);
                  }
                  if (setStatus && res.autobook?.status) {
                    setStatus(res.autobook.status);
                  }
                  if (setHistoryList && res.autobook?.event_history) {
                    setHistoryList(res.autobook.event_history.reverse());
                  }
                })
                .catch((err) => {
                  console.error('Error refreshing autobook data:', err);
                });
            }
          })
          .catch((err) => {
            SaveApiResMessage({
              title: 'Error',
              message: err?.message || 'Failed to load template',
              mode: 'error',
            });
          });
      } else {
        // For regular autobook mode
        const autobooks =
          selectedContainers.length < 1
            ? [selectedContainer]
            : selectedContainers;
        loadAutobookTemplateForContainers({
          AutobookTemplateId: item.id,
          data: {
            autobooks: autobooks,
          },
        }).then((res) => {
          SaveApiResMessage({
            title: res?.data?.messageHeader,
            message: res,
            mode: 'success',
          });
          setReLoadAutobookContainer(true);
        });
      }
    },
  }));

  const handleSavePreferencesClick = (type, item) => {
    setShowSavePreferences(true);
    setPreferenceName(item?.label || '');
    setClickedTemplate(item);
  };

  const handleSavePreferencesSubmit = () => {
    if (!preferenceName || !tableData?.id) return;

    setLoadingSubmit(true);
    saveAutobookPreferences(tableData.id, preferenceName)
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: res,
          mode: 'success',
        });
        setShowSavePreferences(false);
        setPreferenceName('');
        setClickedTemplate(null);
        // Reload templates
        if (parent === 'inventory') {
          AutoBookIndex('available', {
            specifications: [],
            shippingLines: [],
            container_name: '',
          })
            .then((res) => {
              setSavedTemplates(res.data.autobook_templates || []);
            })
            .catch((err) => {
              console.error('Error loading templates:', err);
            });
        }
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err?.message || 'Failed to save preferences',
          mode: 'error',
        });
      })
      .finally(() => {
        setLoadingSubmit(false);
      });
  };

  useEffect(() => {
    setHasError(false);
    const AutobookId = tableData.id;
    const hasChanges =
      autobookMode.autobookId == AutobookId &&
      autobookMode.status !==
        (status === 'ENABLED'
          ? true
          : status === 'DISABLED'
          ? false
          : undefined);

    if (AutobookId && saving_identifier && hasChanges) {
      if (parent === 'inventory' && !isAutobookToggleRef.current) {
        return;
      }
      setAutobookModeLoading(true);
      enableAutoBook({
        AutobookId,
        data: {
          saving_identifier: saving_identifier,
          status: autobookMode.status ? 'ENABLED' : 'DISABLED',
        },
      })
        .then((res) => {
          setAutobookModeLoading(false);
          setStatus(res?.autobook?.status);

          parent !== 'inventory' && setReLoadAutobook(true);
          if (setAutobookModeapiRes)
            setAutobookModeapiRes({
              status: autobookMode.status,
              autobookId: autobookMode.autobookId,
            });
          if (
            isAutobookToggleRef.current &&
            parent === 'inventory' &&
            typeof onAutobookModeChange === 'function'
          ) {
            onAutobookModeChange();
          }
        })
        .catch((err) => {
          SaveApiResMessage({
            title: 'Error',
            message: err || 'Failed to update autobook preferences',
            mode: 'error',
          });
          setAutobookMode({
            status: false,
            autobookId: null,
          });
          if (setAutobookModeapiRes)
            setAutobookModeapiRes({
              status: false,
              autobookId: null,
            });
          setHasError(true);
        })
        .finally(() => {
          setLoading(false);
          setAutobookModeLoading(false);
          setLoadingDeleteTemplate(false);
          isAutobookToggleRef.current = false;
        });
    }
  }, [autobookMode]);

  const autobookChecked = useMemo(() => {
    if (hasError) {
      return status === 'DISABLED' ? false : true;
    } else {
      return status !== undefined
        ? status === 'ENABLED'
          ? true
          : false
        : autobookMode.status;
    }
  }, [autobookMode, hasError, status]);

  const HistoryList = ({ historyList }) => {
    return (
      <div style={{ height: '100%' }}>
        <div className={styles.historyList}>
          <div
            style={{ paddingBottom: '20px', marginLeft: '-38px' }}
            className={styles.ModalTitle}>
            View history of Autobook updates, status changes, and appointments.
          </div>
          {historyList.map((history, index) => (
            <>
              <div className={styles.circleContainer}>
                <div className={styles.circle} />
                <span>
                  {history.event_date &&
                    (() => {
                      const dateObj = new Date(history.event_date);
                      const dateStr = dateObj.toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                      });
                      const timeStr = dateObj
                        .toLocaleTimeString('en-US', {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: false,
                        })
                        .replace(/^([0-9]{2}):([0-9]{2}):[0-9]{2}$/, '$1:$2');
                      return `${dateStr} at ${timeStr}`;
                    })()}
                </span>
              </div>
              <div>
                <div
                  className={styles.row}
                  style={{
                    borderLeftColor:
                      index + 1 === historyList?.length
                        ? 'transparent'
                        : '#E8E8E8',
                  }}>
                  <div className={styles.historyMessageContainer}>
                    <span className={styles.historyMessage}>
                      {history.event_message}
                    </span>
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        maxWidth:
          parent === 'inventory' &&
          (window.innerWidth <= 1024 ? '952px' : '1300px'),
        minWidth:
          parent === 'inventory'
            ? window.innerWidth <= 1024
              ? '865px'
              : '1300px'
            : clickConatiner
            ? window.innerWidth <= 1024
              ? '865px'
              : 'auto'
            : '380px',
        width: parent !== 'inventory' ? width : undefined,
      }}
      className={styles.autobookList}>
      <Modal
        show={showHistoryModal}
        setShow={setShowHistoryModal}
        icon={'historyList'}
        title={'Autobook History'}
        minWidth={'unset'}
        children={
          <span className={styles.deleteModalContent}>
            <HistoryList historyList={historyList} />
          </span>
        }
      />

      <Modal
        show={showDeleteTemplateModal}
        setShow={setShowDeleteTemplateModal}
        icon={'historyList'}
        title={'Delete Preference'}
        submitText={'Yes, delete'}
        notClose={true}
        loadingbutton={loadingDeleteTemplate}
        submit={handleDeleteTemplate}
        children={
          <span className={styles.deleteModalContent}>
            Are you sure you want to delete this preference?
          </span>
        }
      />

      {parent === 'inventory' ? (
        <></>
      ) : (
        <div className={styles.headerRight}>
          <h2 className={styles.title}>
            <ReactSVG src={Icons.autobookList} />
            Autobook List
          </h2>
          <div className={styles.actionButtons}>
            {clickConatiner && (
              <>
                {selectedContainers.length > 1 && (
                  <IconButton
                    onClick={handleDeleteClick}
                    icon={'deleteIcon'}
                    text={'Delete'}
                    color={'#fb3748'}
                    size={'mini'}
                  />
                )}
                <IconButton
                  onClick={handleSavePreferencesClick}
                  icon={'saveData'}
                  text={'Save'}
                  color={'#131617'}
                  size={'mini'}
                />
                <div className={styles.loadButtonContainer}>
                  <IconButton
                    onClick={handleLoadClick}
                    icon={'loadData'}
                    text={'Load'}
                    color={'#131617'}
                    size={'mini'}
                    active={loadAnchorEl}
                  />
                  <ActionMenu
                    componentName={'loadAutobookTemplate'}
                    anchorEl={loadAnchorEl}
                    onClose={handleLoadClose}
                    menuItems={menuItems}
                    className={styles.loadMenu}
                    handleEditTemplate={handleEditTemplate}
                    handleDeleteTemplate={handleDeleteTemplate}
                    setShowDeleteTemplateModal={setShowDeleteTemplateModal}
                    setClickedTemplate={setClickedTemplate}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                  />
                </div>
                <IconButton
                  onClick={handleHistoryClick}
                  icon={'historyList'}
                  text={'History'}
                  color={'#131617'}
                  size={'mini'}
                />
              </>
            )}
          </div>
        </div>
      )}
      <div className={styles.autobookListBody}>
        {!clickConatiner && parent !== 'inventory' ? (
          <div className={styles.emptyState}>
            <ReactSVG src={Icons.infoEmptyList} />
            <h3>Your AutoBook List is Empty!</h3>
            <p>
              As soon as you set up your AutoBook, all your saved items will be
              displayed here for easy access.
            </p>
          </div>
        ) : loading ? (
          <LoadingV2 />
        ) : (
          <div
            id="autobookListBody"
            ref={autobookListBodyRef}
            style={{
              // minWidth:
              //   activeTabInList === 'Booked-Appointment' ? '1360px' : '',
              paddingRight:
                heightUpperThenVh ||
                smallScreen ||
                activeTabInList !== 'autobook-setting'
                  ? '12px'
                  : '0px',
              marginRight:
                heightUpperThenVh ||
                smallScreen ||
                activeTabInList !== 'autobook-setting'
                  ? '-12px'
                  : '0px',
              maxHeight:
                parent === 'inventory' &&
                window.innerHeight < 1367 &&
                window.innerWidth <= 1024
                  ? '39vh'
                  : '',
            }}
            className={styles.autobookTimeDateSelectorContainer}>
            <ContainerInfoRow
              informations={informations}
              tableData={tableData}
            />
            {parent !== 'inventory' ? (
              <div
                style={{
                  width: '78%',
                }}
                className={styles.tabInItemContainer}>
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    className={`${styles.tab} ${tab.className} ${
                      activeTabInList === tab.id ? styles.selected : ''
                    }`}
                    onClick={() => handleTabChange(tab.id)}>
                    <div className={styles.tabContent}>{tab.label}</div>
                  </button>
                ))}
              </div>
            ) : (
              <></>
            )}
            {activeTabInList === 'autobook-setting' ||
            parent === 'inventory' ? (
              <>
                {ABloading ? (
                  <div className="min-h-full">
                    <LoadingV2 />
                  </div>
                ) : (
                  <AutobookTimeDateSelector
                    ABloading={ABloading}
                    setABloading={setABloading}
                    clickConatiner={clickConatiner}
                    activeSection={activeSection}
                    setActiveSection={setActiveSection}
                    settings={settings}
                    AutobookId={tableData.id}
                    setSettings={setSettings}
                    saving_identifier={saving_identifier}
                    status={status}
                    setStatus={setStatus}
                    autobookMode={autobookMode}
                    setAutobookMode={setAutobookMode}
                    reLoadAutobook={reLoadAutobook}
                    setReLoadAutobook={setReLoadAutobook}
                    lfdDate={tableData.lfd}
                    setHistoryList={setHistoryList}
                  />
                )}
              </>
            ) : (
              <Appointments apiData={autobookAppointmentsApiData} />
            )}
          </div>
        )}
        {(clickConatiner || parent === 'inventory') && !loading && (
          <div
            style={{
              margin: parent === 'inventory' && '0px -18px -28px -36px',
              boxShadow: parent === 'inventory' && 'none',
            }}
            className={'autobookOnOffContainer'}>
            {parent === 'inventory' && (
              <div
                className={styles.actionButtons}
                style={{ marginRight: 'auto' }}>
                <IconButton
                  onClick={handleSavePreferencesClick}
                  icon={'saveData'}
                  text={'Save'}
                  color={'#131617'}
                  size={'normal'}
                />
                <div className={styles.loadButtonContainer}>
                  <IconButton
                    onClick={handleLoadClick}
                    icon={'loadData'}
                    text={'Load'}
                    color={'#131617'}
                    size={'normal'}
                    active={loadAnchorEl}
                  />
                  <ActionMenu
                    componentName={'loadAutobookTemplate'}
                    anchorEl={loadAnchorEl}
                    onClose={handleLoadClose}
                    menuItems={menuItems}
                    className={styles.loadMenu}
                    handleEditTemplate={handleEditTemplate}
                    handleDeleteTemplate={handleDeleteTemplate}
                    setShowDeleteTemplateModal={setShowDeleteTemplateModal}
                    setClickedTemplate={setClickedTemplate}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    getContentAnchorEl={null}
                  />
                </div>
                <IconButton
                  onClick={handleHistoryClick}
                  icon={'historyList'}
                  text={'History'}
                  color={'#131617'}
                  size={'normal'}
                />
              </div>
            )}
            {autobookModeLoading ? (
              <span className="autobookCircleLoading">
                <CustomCircularProgress className="w-4 h-4 border-primary-text" />
              </span>
            ) : (
              ''
            )}
            <div
              style={{
                border: autobookChecked
                  ? '1px solid #1FC16B'
                  : '1px solid #EAEAEA',
                color: autobookChecked ? '#1FC16B' : '#525866',
              }}
              className={'autobookOnOff'}>
              AutoBook
              <CustomSwitch
                checked={autobookChecked}
                onChange={() => {
                  isAutobookToggleRef.current = true;
                  setAutobookMode({
                    status: !autobookMode.status,
                    autobookId: autobookMode.autobookId,
                  });
                }}
              />
            </div>
          </div>
        )}
      </div>

      {/* Save Preferences Modal */}
      <Modal
        notClose={true}
        show={showSavePreferences}
        setShow={setShowSavePreferences}
        clickedTemplate={clickedTemplate}
        icon="saveData"
        title={preferenceName ? 'Edit Preferences' : 'Save Preferences'}>
        <div
          style={{ padding: '18px 0px 0px', width: '100%' }}
          className={styles.savePreferencesModalChild}>
          <div style={{ marginBottom: 16 }}>
            {preferenceName
              ? 'Update the name of your saved Autobook preference.'
              : 'Save Autobook preferences to reuse for other containers.'}
          </div>
          <div style={{ marginBottom: 24 }}>
            <label
              style={{ fontWeight: 600, display: 'block', marginBottom: 8 }}>
              Preference Name
            </label>
            <input
              type="text"
              value={preferenceName}
              onChange={(e) => setPreferenceName(e.target.value)}
              placeholder="Enter your Preference Name"
              style={{
                width: '55%',
                padding: '10px 12px',
                border: '1px solid #E3E6E8',
                borderRadius: 6,
                fontSize: 16,
                outline: 'none',
              }}
            />
          </div>
          <div className={styles.buttonContainer}>
            <SubmitButton
              text={'Save'}
              onClick={() => {
                handleSavePreferencesSubmit();
              }}
              loading={loadingSubmit}
              disable={!preferenceName}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AutobookList;
